import { css } from 'styled-system/css';

export function accessCtaClass(size: 'md' | 'lg' = 'lg'): string {
  return css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2',
    height: size === 'lg' ? '48px' : '36px',
    paddingInline: size === 'lg' ? '6' : '4',
    fontSize: size === 'lg' ? 'base' : 'sm',
    fontWeight: 'semibold',
    letterSpacing: '-0.005em',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    background: 'accent.default',
    color: 'text.onAccent',
    border: '1px solid transparent',
    transition:
      'background 200ms {easings.out}, color 200ms {easings.out}, border-color 200ms {easings.out}',
    _hover: {
      color: 'text.primary',
      background:
        'linear-gradient(token(colors.bg.page), token(colors.bg.page)) padding-box, linear-gradient(105deg, token(colors.prism.violet), token(colors.prism.mid), token(colors.prism.green)) border-box',
    },
    _active: { transform: 'translateY(0.5px)' },
    _focusVisible: {
      outline: '2px solid token(colors.border.focus)',
      outlineOffset: '2px',
    },
  });
}

export function ghostCtaClass(size: 'md' | 'lg' = 'md'): string {
  return css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2',
    height: size === 'lg' ? '48px' : '36px',
    paddingInline: size === 'lg' ? '6' : '4',
    fontSize: size === 'lg' ? 'base' : 'sm',
    fontWeight: 'semibold',
    letterSpacing: '-0.005em',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    background: 'transparent',
    color: 'text.primary',
    border: '1px solid token(colors.border.hairline)',
    transition:
      'background 200ms {easings.out}, color 200ms {easings.out}, border-color 200ms {easings.out}',
    _hover: {
      color: 'text.primary',
      background:
        'linear-gradient(token(colors.bg.page), token(colors.bg.page)) padding-box, linear-gradient(105deg, token(colors.prism.violet), token(colors.prism.mid), token(colors.prism.green)) border-box',
      borderColor: 'transparent',
    },
    _active: { transform: 'translateY(0.5px)' },
    _focusVisible: {
      outline: '2px solid token(colors.border.focus)',
      outlineOffset: '2px',
    },
  });
}
